import { render, staticRenderFns } from "./AddOrEdit.vue?vue&type=template&id=999d9d20&scoped=true&"
import script from "./AddOrEdit.vue?vue&type=script&lang=js&"
export * from "./AddOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999d9d20",
  null
  
)

export default component.exports